import React from 'react';
import { HelpCircle } from 'lucide-react';
import * as Tooltip from '@radix-ui/react-tooltip';

interface MetricTooltipProps {
  description: string;
}

export function MetricTooltip({ description }: MetricTooltipProps) {
  return (
    <Tooltip.Provider>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          <button className="inline-flex">
            <HelpCircle className="h-4 w-4 text-gray-400" />
          </button>
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            className="max-w-xs bg-gray-900 text-white px-4 py-2 rounded-lg text-sm leading-relaxed shadow-lg"
            sideOffset={5}
          >
            {description}
            <Tooltip.Arrow className="fill-gray-900" />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
}